const ATTRIBUTION_COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60

const ATTRIBUTION_PARAMETERS = {
  referrer_id: 'npvpn_referrer_id',
  utm_source: 'npvpn_utm_source',
  utm_campaign: 'npvpn_utm_campaign',
} as const

export interface RegistrationAttribution {
  referrer_id?: number
  utm_source?: string
  utm_campaign?: string
}

function readCookie(name: string): string | undefined {
  const cookiePrefix = `${encodeURIComponent(name)}=`
  const cookie = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(cookiePrefix))

  if (!cookie) {
    return undefined
  }

  const value = cookie.slice(cookiePrefix.length)

  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

function writeAttributionCookie(name: string, value: string): void {
  const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : ''

  document.cookie = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    `Max-Age=${ATTRIBUTION_COOKIE_MAX_AGE_SECONDS}`,
    'Path=/',
    'SameSite=Lax',
  ].join('; ') + secureAttribute
}

function getNonEmptyCookie(name: string): string | undefined {
  const value = readCookie(name)?.trim()
  return value || undefined
}

export function captureRegistrationAttribution(
  search = window.location.search
): void {
  const searchParams = new URLSearchParams(search)

  for (const [parameterName, cookieName] of Object.entries(
    ATTRIBUTION_PARAMETERS
  )) {
    if (getNonEmptyCookie(cookieName)) {
      continue
    }

    const value = searchParams.get(parameterName)?.trim()
    if (value) {
      writeAttributionCookie(cookieName, value)
    }
  }
}

export function getRegistrationAttribution(): RegistrationAttribution {
  const attribution: RegistrationAttribution = {}

  const referrerIdValue = getNonEmptyCookie(
    ATTRIBUTION_PARAMETERS.referrer_id
  )
  if (referrerIdValue && /^-?\d+$/.test(referrerIdValue)) {
    const referrerId = Number(referrerIdValue)
    if (Number.isSafeInteger(referrerId)) {
      attribution.referrer_id = referrerId
    }
  }

  const utmSource = getNonEmptyCookie(ATTRIBUTION_PARAMETERS.utm_source)
  if (utmSource) {
    attribution.utm_source = utmSource
  }

  const utmCampaign = getNonEmptyCookie(ATTRIBUTION_PARAMETERS.utm_campaign)
  if (utmCampaign) {
    attribution.utm_campaign = utmCampaign
  }

  return attribution
}
